import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, CssBaseline, useMediaQuery, useTheme } from '@mui/material';
import AdminHeader from './layout/AdminHeader';
import AdminSidebar from './layout/AdminSidebar';
import AdminFooter from './layout/AdminFooter';

export default function DashboardLayout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      minHeight: '100vh',
      backgroundColor: theme.palette.background.default
    }}>
      <CssBaseline />
      <AdminHeader 
        handleDrawerToggle={handleDrawerToggle} 
        isMobile={isMobile} 
      />
      <AdminSidebar 
        mobileOpen={mobileOpen} 
        handleDrawerToggle={handleDrawerToggle} 
        isMobile={isMobile}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 1, sm: 2, md: 3 },
          width: { 
            xs: '100%', 
            sm: `calc(100% - ${drawerWidth}px)`
          },
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          marginLeft: { 
            xs: 0, 
            sm: `${drawerWidth}px` 
          },
          transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          ...(mobileOpen && {
            [theme.breakpoints.down('sm')]: {
              marginLeft: `${drawerWidth}px`,
              width: `calc(100% - ${drawerWidth}px)`,
            },
          }),
        }}
      >
        <ToolbarSpacer isMobile={isMobile} />
        <Box sx={{ 
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
          position: 'relative'
        }}>
          <Outlet />
        </Box>
        <AdminFooter isMobile={isMobile} />
      </Box>
    </Box>
  );
}

const ToolbarSpacer = ({ isMobile }) => (
  <Box sx={{ 
    height: { 
      xs: 56, 
      sm: 64 
    },
    ...(isMobile && {
      position: 'sticky',
      top: 0,
      zIndex: theme => theme.zIndex.appBar - 1
    })
  }} />
);

const drawerWidth = 260;